import { StyledButton as Button } from './Button.styled';

export default Button;
